/**
 * Legacy placeholder warehouses from ICL orphan repair (LINK-* / "Auto link N").
 * Hide from MRP / forecast pickers even if an older API still returns them.
 */
export function isPlaceholderWarehouseRow(w) {
  const code = String(w?.wh_code ?? '').trim().toUpperCase();
  const name = String(w?.wh_name ?? '').trim();
  if (code.startsWith('LINK-')) return true;
  if (/^auto\s+link\b/i.test(name)) return true;
  return false;
}

export function filterMrpWarehouseList(rows) {
  const list = Array.isArray(rows) ? rows : [];
  return list.filter((w) => !isPlaceholderWarehouseRow(w));
}

/** SAP B1–style `location` is often unset; use address from API or suffix in wh_name e.g. "(UNIT I)". */
export function resolveMrpWarehouseDisplayLocation(w) {
  const fromField = String(w?.location ?? '').trim();
  if (fromField) return fromField;
  const name = String(w?.wh_name ?? '').trim();
  const m = name.match(/\(([^)]+)\)\s*$/);
  if (m) return m[1].trim();
  return '';
}
